import { Box, Button, CircularProgress, Typography } from '@material-ui/core'
import confirmImg from 'assets/images/confirm.svg'
import confirmBranchImg from 'assets/images/confirmBranch.svg'
import separationImg from 'assets/images/separation.svg'
import { usePopup } from 'hooks/usePopup'
import { IProduct } from 'interfaces/IProduct'
import AlertWeighinsNoScanner from './AlertWeighinsWithoutScanner'
import { enStatusItem } from 'interfaces/ISeparationItem'
import { useMemo } from 'react'
import { IDataConfirmItem } from 'services/separationItemService'

import { useStyles } from './styles'

export interface ICardProduct {
  view?: 'separation' | 'fastTrack' | 'conference'
  product: IProduct
  isConfirm?: boolean
  isVisualization?: boolean
  loading?: boolean
  handleBranchConfirmProduct?: (weighings?: number[]) => void
  handleConfirmProduct?: (x: Omit<IDataConfirmItem, 'itemId'>) => Promise<IProduct | void>
}

const CardProduct = ({
  view,
  product,
  isConfirm,
  loading,
  isVisualization,
  handleBranchConfirmProduct,
  handleConfirmProduct,
}: ICardProduct) => {
  const classes = useStyles()
  const {
    name,
    converted_quantity,
    image,
    instructions,
    quantity,
    status,
    type,
    use_conversion_flow,
    unity_product_base,
  } = product
  const { addPopup } = usePopup()

  const productType = unity_product_base === 'unidade' ? 'Un' : 'Kg'
  

  const handleBreak = () => {
    handleBranchConfirmProduct && handleBranchConfirmProduct()
  }

  const handleConfirm = async () => {
    try {
      if (!handleConfirmProduct) {
        return
      }
      await handleConfirmProduct({ statusId: enStatusItem.separated })
    } catch (err: any) {
      addPopup({
        type: 'error',
        title: 'Erro ao confirmar item',
        description: err?.message ?? '',
      })
    }
  }

  return (
    <Box id="card-product-separation">
      <Box className={classes.imageStyle}>
        <div className={`${classes.image} ${isConfirm && classes.imageConfimed}`}>
          <img src={image || separationImg} alt="Imagem do produto" />
        </div>

        <div className={classes.infos}>
          <Typography className={isConfirm ? classes.titleActive : classes.title}>
            {name}
          </Typography>

          <Typography className={isConfirm ? classes.quantityActive : classes.quantity}>
            <>
            Quantidade total:
            <strong>{` ${converted_quantity || quantity} ${productType}`}</strong>
            </>
          </Typography>
          <AlertWeighinsNoScanner product={product} />
        </div>
      </Box>
      {instructions && (
        <Typography variant="subtitle1" className={classes.obs}>
          Obs: <span>{instructions}</span>
        </Typography>
      )}

      {!isVisualization ? (
        <Box
          display="flex"
          justifyContent={product?.quantity !== 0 ? 'space-between' : 'right'}
          marginTop="1.5rem"
        >
          {isConfirm ? (
            <img
              src={status === 2 ? confirmImg : confirmBranchImg}
              className={classes.confirmIcon}
              alt="Confirmado"
            />
          ) : (
            <>
              {product?.quantity !== 0 && (
                <Button
                  variant="contained"
                  onClick={handleBreak}
                  className={classes.branchConfirmBtn}
                  disabled={loading}
                >
                  Quebra
                </Button>
              )}

              <Button
                variant="contained"
                onClick={handleConfirm}
                className={classes.confirmBtn}
                disabled={loading}
              >
                {loading ? <CircularProgress size={22} /> : 'Confirmar'}
              </Button>
            </>
          )}
        </Box>
      ) : null}
    </Box>
  )
}

export default CardProduct
